var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.metaData
    ? _c(
        "div",
        {
          staticClass: "text-field",
          class:
            ((_obj = {}),
            (_obj[_vm.metaData.addendumClassName] = _vm.metaData.isRevised),
            _obj),
        },
        [
          (!_vm.readonly || _vm.viewModeWithValue) && !_vm.hideLabel
            ? _c(
                "label",
                { class: { "required-flag": _vm.required && !_vm.readonly } },
                [
                  _vm.metaData.fieldName
                    ? [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t("tender.general." + _vm.metaData.fieldName)
                            ) +
                            ":\n      "
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("pre", [
            _vm.viewModeWithValue
              ? _c("p", [_vm._v(_vm._s(_vm.metaData.value))])
              : _vm._e(),
          ]),
          _vm._v(" "),
          !_vm.readonly
            ? _c("div", { staticClass: "row text-input" }, [
                _c("textarea", {
                  directives: [
                    { name: "autosize", rawName: "v-autosize" },
                    { name: "hkldinput", rawName: "v-hkldinput" },
                  ],
                  staticClass: "autosize",
                  class: {
                    "small-2 medium-2 large-2 columns": _vm.metaData.text,
                  },
                  attrs: {
                    name: _vm.metaData.fieldName,
                    required: _vm.required,
                  },
                  domProps: { value: _vm.metaData.value },
                  on: {
                    change: _vm.updateFieldValue,
                    input: _vm.updateFieldValue,
                  },
                }),
                _vm._v(" "),
                _c("pre", [
                  _vm.metaData.text
                    ? _c("p", { staticClass: "additional-text" }, [
                        _vm._v(_vm._s(_vm.metaData.text)),
                      ])
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }